module.exports = __webpack_public_path__ + "static/media/42_A.877f3aeb.png";